import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import Wait from "../../../../shared/assets/icons/waiting.svg";

export const PageLoader = () => {
  return (
    <OfferStatusInfo
      iconSrc={Wait}
      isRotate={true}
      title="Ваш счет формируется"
      description="Ожидайте, ваш счет формируется. В скором времени вы увидите нужную информацию"
      buttonVariant="primary"
      link=""
      isBtnVisible={false}
    />
  );
};
